import script from "./BlockTransactionFormAmount.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTransactionFormAmount.vue?vue&type=script&setup=true&lang=js"

import "./BlockTransactionFormAmount.vue?vue&type=style&index=0&id=9926db4c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9926db4c"]])

export default __exports__